export const langText: any = {
    us: {
        compare_at_price_before: '通常価格',
        price_after: '（税込）',
    },
    jp: {
        compare_at_price_before: '通常価格',
        price_after: '（税込）',
    },
};
